module.exports = __webpack_public_path__ + "static/media/huffpo-logo.c25bdfc1.png";